import { default as domainScenario } from './scenario/store'

export default {
    domainScenario
}
